import {http_client} from "@/plugins/http_client";

const listarMenu = async () => await http_client(`/api/v1/show-menu`);


export default {
    listarMenu
}